module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cd-Db-Ed-Gb.1ec235a0.png";